import React from "react";

export default function LawyerImage({
  src = "984077759.svg",
  alt = "Юрист — Наро-Фоминск",
}) {
  return (
    <figure className={`overflow-hidden w-full  `}>
      <img
        src={src}
        alt={alt}
        loading="lazy"
        className="w-full min-w-[1024px] h-auto justify-self-center"
      />
    </figure>
  );
}
